import React, { useContext } from 'react'
import { Form } from 'antd'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { ColumnProps } from 'antd/lib/table'
import { contextCompanyIdSelector } from '../../../../../../../redux/context/company/selectors'
import { CompanyDashboardItemContext, CompanyDashboardContextType } from '../../DashboardItemProvider'
import DashboardItemFields from '../DasboardItemFieds'
import SelectionTableInput from '../SelectionTableInput'
import { BaseSalesItem } from './SalesChartFields'
import useSalesRecordItems from './useSalesRecordItems'
import { useColumnSearchProps } from '../../../../../../../components/Table/useColumSearchProps'

const SalesTableFields = () => {
  const { t } = useTranslation()
  const { companyDashboardItemPreferenceSelection } = useContext(
    CompanyDashboardItemContext
  ) as CompanyDashboardContextType

  const record = companyDashboardItemPreferenceSelection?.params.record
  const companyId = useSelector(contextCompanyIdSelector)
  const { data: salesItems, isLoading: itemsLoading } = useSalesRecordItems(record, companyId)

  const columns: ColumnProps<BaseSalesItem>[] = [
    {
      title: t(`global:name`),
      key: 'name',
      dataIndex: 'name',
      defaultSortOrder: 'ascend',
      sorter: (a, b) => a.name.localeCompare(b.name),
      ...useColumnSearchProps('name')
    }
  ]

  return (
    <>
      <DashboardItemFields />
      <Form.Item label={t(`global:${record?.slice(0, -1)}`)} name={['params', 'ids']}>
        <SelectionTableInput loading={itemsLoading} dataSource={salesItems} columns={columns} />
      </Form.Item>
    </>
  )
}

export default SalesTableFields
